import React, { useState, useMemo } from "react";
import { jsPDF } from "jspdf";
import "./roadmap.css";

export default function Roadmap({ checkpoints, projectTitle, category, tags, onCreate }) {
  const [completed, setCompleted] = useState({});
  const [created, setCreated] = useState(false);

  // Freeze project start date when the component mounts
  const startDate = useMemo(() => new Date(), []);

  const toggleComplete = (phase, idx) => {
    setCompleted((prev) => ({
      ...prev,
      [`${phase}-${idx}`]: !prev[`${phase}-${idx}`],
    }));
  };

  // Get the start date for a checkpoint (week-based)
  const getCheckpointStartDate = (week) => {
    const d = new Date(startDate);
    d.setDate(d.getDate() + (week - 1) * 7);
    return d;
  };

  // Calculate expiration (end of that week)
  const getCheckpointExpiration = (week) => {
    const d = getCheckpointStartDate(week);
    d.setDate(d.getDate() + 6); // expire at end of week
    return d;
  };

  const formatDate = (date) =>
    date.toLocaleDateString(undefined, { month: "short", day: "numeric" });

  
  return (
    <div className="roadmap-container">
      <div className="flex justify-end mb-4">
        <button
            onClick={onCreate}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
        >
            Create
        </button>
      </div>


      {Object.entries(checkpoints).map(([phase, cps], pIdx) => (
        <div key={phase} className="phase-section">
            <h2 className="phase-title">{phase}</h2>
            <div className="phase-checkpoints">
            {cps.map((cp, i) => {
                const key = `${phase}-${i}`;
                const isDone = completed[key];
                const start = getCheckpointStartDate(cp.week);
                const expire = getCheckpointExpiration(cp.week);

                return (
                    <div
                        key={i}
                        className={`checkpoint-chip animate-fadeInUp ${isDone ? "done" : ""}`}
                        style={{ animationDelay: `${i * 0.1}s` }}
                        onClick={() => toggleComplete(phase, i)}
                        >
                        <div className="chip-header">
                            <span className="week">
                            {isDone ? "✅" : "⚡"} Week {cp.week} •{" "}
                            {new Date(cp.startDate).toLocaleDateString(undefined, { month: "short", day: "numeric" })} →{" "}
                            {new Date(cp.endDate).toLocaleDateString(undefined, { month: "short", day: "numeric" })}
                            </span>
                            <span className="hours">{cp.hours} hrs</span>
                        </div>
                        <p className="chip-text">{cp.text}</p>
                    </div>

                );
            })}
            </div>
        </div>
      ))}

    </div>
  );
}
